import parse from 'html-react-parser';
import { ReactNode } from 'react';

import {
  breakHtmlForAll,
  breakHtmlForCamelCase,
  breakHtmlForSlash,
  breakHtmlForPeriod,
  breakHtmlForUnderscore,
  breakHtmlForDoubleColon,
  breakHtmlForWhitespace,
} from './break-html';

function breakHtmlForAllReact(
  ...args: Parameters<typeof breakHtmlForAll>
): ReactNode {
  return parse(breakHtmlForAll(...args));
}

function breakHtmlForCamelCaseReact(
  ...args: Parameters<typeof breakHtmlForCamelCase>
): ReactNode {
  return parse(breakHtmlForCamelCase(...args));
}

function breakHtmlForSlashReact(
  ...args: Parameters<typeof breakHtmlForSlash>
): ReactNode {
  return parse(breakHtmlForSlash(...args));
}

function breakHtmlForPeriodReact(
  ...args: Parameters<typeof breakHtmlForPeriod>
): ReactNode {
  return parse(breakHtmlForPeriod(...args));
}

function breakHtmlForUnderscoreReact(
  ...args: Parameters<typeof breakHtmlForUnderscore>
): ReactNode {
  return parse(breakHtmlForUnderscore(...args));
}

function breakHtmlForDoubleColonReact(
  ...args: Parameters<typeof breakHtmlForDoubleColon>
): ReactNode {
  return parse(breakHtmlForDoubleColon(...args));
}

function breakHtmlForWhitespaceReact(
  ...args: Parameters<typeof breakHtmlForWhitespace>
): ReactNode {
  return parse(breakHtmlForWhitespace(...args));
}

export {
  breakHtmlForAllReact,
  breakHtmlForCamelCaseReact,
  breakHtmlForSlashReact,
  breakHtmlForPeriodReact,
  breakHtmlForUnderscoreReact,
  breakHtmlForDoubleColonReact,
  breakHtmlForWhitespaceReact,
};
